import { render, staticRenderFns } from "./ClipPlane.vue?vue&type=template&id=1ae3e9bf"
import script from "./ClipPlane.vue?vue&type=script&lang=ts"
export * from "./ClipPlane.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ae3e9bf')) {
      api.createRecord('1ae3e9bf', component.options)
    } else {
      api.reload('1ae3e9bf', component.options)
    }
    module.hot.accept("./ClipPlane.vue?vue&type=template&id=1ae3e9bf", function () {
      api.rerender('1ae3e9bf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Viewer/ClipPlane.vue"
export default component.exports